export const PRODUCT_ALTERNATIVES_ELEMENT_ID = 'product-alternatives';
export const NUSHOP_PORTAL_ROOT_ID = 'nushop-portal-root';

export const EROTICS_NAVIGATION_VALUES = [76526, 39829, 86008, 86219, 76566];
